var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnRendicontazioni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.965,
    height: 17.572,
    viewBox: "0 0 21.965 17.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(-16 -64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(16 64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M36.5,77.179H17.464A1.466,1.466,0,0,1,16,75.714V65.464A1.466,1.466,0,0,1,17.464,64H36.5a1.466,1.466,0,0,1,1.464,1.464v10.25A1.466,1.466,0,0,1,36.5,77.179ZM17.464,65.464v10.25H36.5V65.464Z",
    transform: "translate(-16 -64)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(17.464 77.911)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M66.3,369.464H48.732a.732.732,0,1,1,0-1.464H66.3a.732.732,0,1,1,0,1.464Z",
    transform: "translate(-48 -368)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(18.929 80.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M95.375,417.464H80.732a.732.732,0,0,1,0-1.464H95.375a.732.732,0,1,1,0,1.464Z",
    transform: "translate(-80 -416)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(22.589 66.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M164.393,120.786a4.393,4.393,0,1,1,4.393-4.393A4.4,4.4,0,0,1,164.393,120.786Zm0-7.322a2.929,2.929,0,1,0,2.929,2.929A2.932,2.932,0,0,0,164.393,113.464Z",
    transform: "translate(-160 -112)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(32.84 64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M388.393,69.125A4.4,4.4,0,0,1,384,64.732a.732.732,0,0,1,1.464,0,2.932,2.932,0,0,0,2.929,2.929.732.732,0,1,1,0,1.464Z",
    transform: "translate(-384 -64)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(16 64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M16.732,69.125a.732.732,0,1,1,0-1.464,2.932,2.932,0,0,0,2.929-2.929.732.732,0,1,1,1.464,0A4.4,4.4,0,0,1,16.732,69.125Z",
    transform: "translate(-16 -64)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(32.84 72.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M384.732,245.125a.732.732,0,0,1-.732-.732A4.4,4.4,0,0,1,388.393,240a.732.732,0,1,1,0,1.464,2.932,2.932,0,0,0-2.929,2.929A.732.732,0,0,1,384.732,245.125Z",
    transform: "translate(-384 -240)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(16 72.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M20.393,245.125a.732.732,0,0,1-.732-.732,2.932,2.932,0,0,0-2.929-2.929.732.732,0,0,1,0-1.464,4.4,4.4,0,0,1,4.393,4.393A.732.732,0,0,1,20.393,245.125Z",
    transform: "translate(-16 -240)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnRendicontazioni);
export default __webpack_public_path__ + "static/media/icn_rendicontazioni.bf7cb38a.svg";
export { ForwardRef as ReactComponent };